import { Trans } from "@lingui/react/macro";
import { enterToClick } from '@integration-frontends/common/ui';
import { useDependencyInjector } from '@integration-frontends/core/di-container/react';
import { containerSelectors } from '@integration-frontends/integration/core/application';
import { Asset, Attachment } from '@integration-frontends/integration/core/model';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  ATTACHMENT_SELECTOR_FEATURES_TOKEN,
  AttachmentSelectorFeature,
  IAttachmentSelectorFeaturesService,
} from '../../../../features';
import { useAttachmentSelectorNavigation } from '../../../navigation';
import { AttachmentOptionsMenu } from '../../attachment-options-menu';
import { ThumbnailOverlay } from '../../thumbnail-overlay';
import { AttachmentThumbnailBase } from './attachment-thumbnail-base';
import { AttachmentThumbnailProps } from './attachment-thumbnail-props';

export function NavigatableAttachmentThumbnail(props: AttachmentThumbnailProps) {
  const featureService: IAttachmentSelectorFeaturesService = useDependencyInjector(
    ATTACHMENT_SELECTOR_FEATURES_TOKEN,
  );

  return (
    <div
      className={classNames('attachment-thumbnail', {
        'with-padding': featureService.hasFeature(AttachmentSelectorFeature.DragAndDrop),
      })}
    >
      <AttachmentThumbnailBase {...props} overlay={<Overlay {...props} />} />
    </div>
  );
}

interface OverlayProps {
  asset: Asset;
  attachment: Attachment;
  containerId: string;
}

function Overlay({ asset, attachment, containerId }: OverlayProps) {
  const container = useSelector((state) => containerSelectors.selectById(state, containerId));
  const navigation = useAttachmentSelectorNavigation();
  const selectedContainer = useSelector((state) =>
    containerSelectors.selectById(state, containerId),
  );
  const [menuFocus, setMenuFocus] = useState(false);

  const action = (
    <a
      data-testid="attachment-view-details-btn"
      className="attachment-adjust-margin button-neutral w-max"
      onClick={() => navigation.goToAssetDetails(asset.id, selectedContainer.id, attachment.id)}
      tabIndex={0}
      onFocus={() => setMenuFocus(true)}
      onBlur={() => setMenuFocus(false)}
      onKeyDown={enterToClick}
    >
      <Trans>View details</Trans>
    </a>
  );

  return (
    <ThumbnailOverlay
      className={`asset-overlay ${menuFocus && 'show'}`}
      centerElement={action}
      topElement={
        <AttachmentOptionsMenu
          asset={asset}
          attachment={attachment}
          container={container}
          onFocus={() => setMenuFocus(true)}
          onBlur={() => setMenuFocus(false)}
        />
      }
    />
  );
}
